// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.berry-checkout-timeLine {
  width: 66.6%;
  margin: 200px auto 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 64px;
}

.berry-checkout-timeLine .berry-checkout-timeLineItem,
.berry-checkout-timeLine .berry-checkout-timeLineDivider {
  text-decoration: none;
  text-align: center;
  color: var(--color-text-gray);
  width: max-content;
}

.berry-checkout-timeLine .berry-checkout-timeLineDivider {
  width: 300px;
  height: 3px;
  background-color: var(--color-text-gray);
  margin-top: -40px;
}

.berry-checkout-timeLine .berry-checkout-timeLineItem.active {
  color: var(--color-text-dark);
}

.berry-checkout-timeLine .berry-checkout-timeLineDivider.active {
  background-color: var(--color-blue-dark);
}

.berry-checkout-timeLine
  .berry-checkout-timeLineItem
  .berry-checkout-timeLineIcon {
  display: block;
  width: 64px;
  height: 64px;
  color: var(--color-text-gray);
  background-color: var(--color-white-cream);
  border-radius: 100%;
  text-align: center;
  line-height: 64px;
  font-size: 32px;
}

.berry-checkout-timeLine
  .berry-checkout-timeLineItem.active
  .berry-checkout-timeLineIcon {
  background-color: var(--color-blue-dark);
  color: var(--color-white-main);
}

.berry-checkout-timeLine
  .berry-checkout-timeLineItem
  .berry-checkout-timeLineMessage {
  display: block;
  font-weight: 500;
  margin: 5px auto;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  color: var(--color-text-gray);
  text-align: center;
}

.berry-checkout-timeLine
  .berry-checkout-timeLineItem.active
  .berry-checkout-timeLineMessage {
  color: var(--color-text-dark);
}

@media only screen and (max-width: 600px) {
  .berry-checkout-timeLine {
    width: 90%;
    column-gap: 16px;
    margin: 50px auto;
    padding: 0 10px;
  }

  .berry-checkout-timeLine .berry-checkout-timeLineDivider {
    width: 75px;
    height: 3px;
    margin-top: -25px;
  }
  .berry-checkout-timeLine
    .berry-checkout-timeLineItem
    .berry-checkout-timeLineIcon {
    display: block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
  }
  .berry-checkout-timeLine
  .berry-checkout-timeLineItem
  .berry-checkout-timeLineMessage {
  display: block;
  font-weight: 500;
  margin: 5px auto;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
}
}

@media only screen and (min-width: 601px) and (max-width: 1024px) {
  .berry-checkout-timeLine {
    width: 82.5%;
    column-gap: 16px;
    margin: 200px auto 50px;
    padding: 0 10px;
  }

  .berry-checkout-timeLine .berry-checkout-timeLineDivider {
    width: 170px;
    height: 3px;
    margin-top: -25px;
  }
  .berry-checkout-timeLine
    .berry-checkout-timeLineItem
    .berry-checkout-timeLineIcon {
    display: block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    font-size: 20px;
  }
  .berry-checkout-timeLine
  .berry-checkout-timeLineItem
  .berry-checkout-timeLineMessage {
  display: block;
  font-weight: 500;
  margin: 5px auto;
  font-family: "Poppins", sans-serif;
  font-size: 12px;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/checkout/Checkout.css"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;EAGE,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;EACnB;EACA;;;IAGE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;;;EAGA,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;AACA;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,iBAAiB;EACnB;EACA;;;IAGE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;EACjB;EACA;;;EAGA,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;AACA","sourcesContent":["@import url(\"../../App.css\");\n\n.berry-checkout-timeLine {\n  width: 66.6%;\n  margin: 200px auto 50px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  column-gap: 64px;\n}\n\n.berry-checkout-timeLine .berry-checkout-timeLineItem,\n.berry-checkout-timeLine .berry-checkout-timeLineDivider {\n  text-decoration: none;\n  text-align: center;\n  color: var(--color-text-gray);\n  width: max-content;\n}\n\n.berry-checkout-timeLine .berry-checkout-timeLineDivider {\n  width: 300px;\n  height: 3px;\n  background-color: var(--color-text-gray);\n  margin-top: -40px;\n}\n\n.berry-checkout-timeLine .berry-checkout-timeLineItem.active {\n  color: var(--color-text-dark);\n}\n\n.berry-checkout-timeLine .berry-checkout-timeLineDivider.active {\n  background-color: var(--color-blue-dark);\n}\n\n.berry-checkout-timeLine\n  .berry-checkout-timeLineItem\n  .berry-checkout-timeLineIcon {\n  display: block;\n  width: 64px;\n  height: 64px;\n  color: var(--color-text-gray);\n  background-color: var(--color-white-cream);\n  border-radius: 100%;\n  text-align: center;\n  line-height: 64px;\n  font-size: 32px;\n}\n\n.berry-checkout-timeLine\n  .berry-checkout-timeLineItem.active\n  .berry-checkout-timeLineIcon {\n  background-color: var(--color-blue-dark);\n  color: var(--color-white-main);\n}\n\n.berry-checkout-timeLine\n  .berry-checkout-timeLineItem\n  .berry-checkout-timeLineMessage {\n  display: block;\n  font-weight: 500;\n  margin: 5px auto;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 14px;\n  color: var(--color-text-gray);\n  text-align: center;\n}\n\n.berry-checkout-timeLine\n  .berry-checkout-timeLineItem.active\n  .berry-checkout-timeLineMessage {\n  color: var(--color-text-dark);\n}\n\n@media only screen and (max-width: 600px) {\n  .berry-checkout-timeLine {\n    width: 90%;\n    column-gap: 16px;\n    margin: 50px auto;\n    padding: 0 10px;\n  }\n\n  .berry-checkout-timeLine .berry-checkout-timeLineDivider {\n    width: 75px;\n    height: 3px;\n    margin-top: -25px;\n  }\n  .berry-checkout-timeLine\n    .berry-checkout-timeLineItem\n    .berry-checkout-timeLineIcon {\n    display: block;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 20px;\n  }\n  .berry-checkout-timeLine\n  .berry-checkout-timeLineItem\n  .berry-checkout-timeLineMessage {\n  display: block;\n  font-weight: 500;\n  margin: 5px auto;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12px;\n}\n}\n\n@media only screen and (min-width: 601px) and (max-width: 1024px) {\n  .berry-checkout-timeLine {\n    width: 82.5%;\n    column-gap: 16px;\n    margin: 200px auto 50px;\n    padding: 0 10px;\n  }\n\n  .berry-checkout-timeLine .berry-checkout-timeLineDivider {\n    width: 170px;\n    height: 3px;\n    margin-top: -25px;\n  }\n  .berry-checkout-timeLine\n    .berry-checkout-timeLineItem\n    .berry-checkout-timeLineIcon {\n    display: block;\n    width: 40px;\n    height: 40px;\n    line-height: 40px;\n    font-size: 20px;\n  }\n  .berry-checkout-timeLine\n  .berry-checkout-timeLineItem\n  .berry-checkout-timeLineMessage {\n  display: block;\n  font-weight: 500;\n  margin: 5px auto;\n  font-family: \"Poppins\", sans-serif;\n  font-size: 12px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
